import type { Size, SizeAdapted } from "~/common/interfaces/entities/size.interface";

export const getSizeDefault = (): Size => ({
	id: 0,
	width: 0,
	height: 0,
	length: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString()
});

export const getSizeAdaptedDefault = (): SizeAdapted => ({
	id: 0,
	name: "",
	width: 0,
	height: 0,
	length: 0,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString()
});
